import { Component, Input } from '@angular/core';

import { ChartInfoPanelModel } from '../typings/chart-info-panel';

// A readout beside the pointer: a title and one row per series with swatch, value and prior
@Component({
  selector   : 'wor-chart-info-panel',
  styles: [ require('./chart-info-panel.component.scss') ],
  template: require('./chart-info-panel.component.html')
})
export class ChartInfoPanelComponent {
  @Input() model : ChartInfoPanelModel;

  trackByIndex ( index : number ) : number {
    return index;
  }
}
